// extracted by mini-css-extract-plugin
export var hero = "contact-module--hero--roaDF";
export var bg = "contact-module--bg--ecXQH";
export var desktop = "contact-module--desktop--WIk4T";
export var mobile = "contact-module--mobile--W4xAd";
export var history = "contact-module--history--pOb0h";
export var manifest = "contact-module--manifest--7Pnag";
export var practice = "contact-module--practice--Lb-m4";
export var firstImage = "contact-module--firstImage--ozmcs";
export var lastImage = "contact-module--lastImage--cWje8";
export var videoContainer = "contact-module--videoContainer--iUE+L";
export var videoContent = "contact-module--videoContent--Rzi2P";
export var bridgeCover = "contact-module--bridgeCover--eKC-d";
export var bridgeImage = "contact-module--bridgeImage--5GCtC";
export var historyTwo = "contact-module--historyTwo--fWfhx";
export var historyTwoImage = "contact-module--historyTwoImage--UD0b9";
export var info = "contact-module--info--rbZXj";
export var technologies = "contact-module--technologies--qqpRX";
export var slide = "contact-module--slide--dViSD";
export var dots = "contact-module--dots--JtoMx";
export var practiceWrapper = "contact-module--practiceWrapper--XxZ6z";
export var blog = "contact-module--blog--IblDW";
export var tab1 = "contact-module--tab1--ndi1R";
export var tab2 = "contact-module--tab2--wvnRj";
export var tab3 = "contact-module--tab3--8mi+6";
export var tab4 = "contact-module--tab4--r2sWp";
export var practiceContainer = "contact-module--practiceContainer--oFmVD";
export var arrow = "contact-module--arrow--A4s7j";
export var workWithUsHero = "contact-module--work-with-us-hero--AMlji";
export var hidden = "contact-module--hidden--0J8oP";
export var phoneAddress = "contact-module--phone-address--oPLI4";
export var titleContainer = "contact-module--titleContainer--g24DZ";
export var addressIcons = "contact-module--addressIcons--J42+N";
export var formWrapper = "contact-module--form-wrapper--G0dbi";
export var radioGroup = "contact-module--radio-group--aJh5H";
export var checked = "contact-module--checked--Zxjse";
export var partTeam = "contact-module--part-team--3HSs9";
export var partTeamText = "contact-module--part-team-text--7vMem";
export var modal = "contact-module--modal--RXar1";
export var ombudsman = "contact-module--ombudsman--XIOjA";
export var ombudsmanImage = "contact-module--ombudsmanImage--Lx3U2";
export var providers = "contact-module--providers--CTKbN";
export var workWithUs = "contact-module--work-with-us--UTBfy";
export var availableRolesContainer = "contact-module--available-roles-container--AxrvN";
export var workSubtitle = "contact-module--work-subtitle--lv6sb";
export var availableVacancies = "contact-module--available-vacancies--oX48v";
export var accordionItem = "contact-module--accordion-item--eaJpP";
export var accordionContent = "contact-module--accordion-content--eEUa8";
export var containerDescription = "contact-module--container-description--+UuPx";
export var activeDescription = "contact-module--active-description--W+jY9";
export var file = "contact-module--file--lsLa6";
export var remove = "contact-module--remove--+p7y1";
export var subject = "contact-module--subject--h4ibL";
export var checkbox = "contact-module--checkbox--MHyb0";
export var sideInput = "contact-module--sideInput--HX0UW";
export var smallLast = "contact-module--smallLast--fjaRs";
export var small = "contact-module--small--AM0SD";
export var close = "contact-module--close--RcGRb";
export var wide = "contact-module--wide--YYkjW";
export var wideText = "contact-module--wideText--RrB3R";
export var medium = "contact-module--medium--gLGWe";